import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { EffectsContainer } from 'mixins/withEffects';
import { ServicesContext } from 'services/context';
import { TextThreadEditorVMConfig } from '../textThread';
import CommentEditorVM from './comment';
import './inlineComment.html';
import './inlineComment.scss';

components.preload('topic-usercontent-inline');

@injectable()
export default class InlineCommentEditorVM extends CommentEditorVM {
    mediaSize = 100

    createDateLabel: PureComputed<string | undefined>

    constructor(
        @inject(wccModules.componentConfig) model: TextThreadEditorVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.servicesContext) ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(model, info, storage, ctx, effects);

        const createDate = ko.pureComputed(() => this.thread()?.createDate())
        this.createDateLabel = createDate.mapNotNull(date => moment(date).fromNow());

        ko.applyBindingsToNode(info.element, {
            'css': {
                'comment-editor-inline': true
            }
        }, this);
    }
}